'use strict';

var $ = require('jquery');

$.ajaxSetup({
  beforeSend: function beforeSend(xhr, settings) {
    if (settings.type == 'POST' || settings.type == 'PUT' || settings.type == 'DELETE') {
      var getCookie = function getCookie(name) {
        var cookieValue = null;
        if (document.cookie && document.cookie != '') {
          var cookies = document.cookie.split('; ');
          for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) == name + '=') {
              cookieValue = decodeURIComponent(cookie.substring(name.length + 1));

              // Check if cookie contains ; in the end
              // If the cookie is in the end of the string then it won't
              // if (cookieValue[cookieValue.length - 1] === ';') {
              //   cookieValue = cookieValue.substring(0, cookieValue.length - 1);
              // }
              break;
            }
          }
        }
        return cookieValue;
      };

      if (!(/^http:.*/.test(settings.url) || /^https:.*/.test(settings.url))) {
        // Only send the token to relative URLs i.e. locally.
        xhr.setRequestHeader("X-CSRF-Token", getCookie('csrftoken'));
      }
    }
  },

  error: function error(xhr) {

    switch (xhr.status) {

      // Unauthorized
      case 403:
        if (window.location !== '/') {
          window.location = '/';
        }
        break;

    }
  }
});

function Request() {

  var request = this;

  /* An abstraction over jQuerys ajax functionality */
  request.ajax = function (type, url, params) {
    return $.ajax({
      cache: false,
      type: type,
      url: '/api/' + url,
      dataType: 'jsonp',
      contentType: 'application/json',
      data: params
    });
  };

  /* GET shorthand for ajax request */
  request.get = function (url, params) {
    return request.ajax('GET', url, params);
  };

  /* POST shorthand for ajax request */
  request.post = function (url, params) {
    return request.ajax('POST', url, JSON.stringify(params));
  };

  /* DELETE shorthand for ajax request */
  request['delete'] = function (url) {
    return request.ajax('DELETE', url);
  };

  /* PUT shorthand for ajax request */
  request.put = function (url, params) {
    return request.ajax('PUT', url, JSON.stringify(params));
  };
}

module.exports = new Request();


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/api/request.js
 **/